function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import Vue from 'vue';
import SizeMixin from '../../mixins/size.js';
import TagMixin from '../../mixins/tag.js';
import ListenersMixin from '../../mixins/listeners.js';
import { slot, mergeSlot } from '../../utils/slot.js';
var defaultViewBox = '0 0 24 24';

var sameFn = function sameFn(i) {
  return i;
};

var ionFn = function ionFn(i) {
  return "ionicons ".concat(i);
};

var libMap = {
  'mdi-': function mdi(i) {
    return "mdi ".concat(i);
  },
  'icon-': sameFn,
  // fontawesome equiv
  'bt-': function bt(i) {
    return "bt ".concat(i);
  },
  'eva-': function eva(i) {
    return "eva ".concat(i);
  },
  'ion-md': ionFn,
  'ion-ios': ionFn,
  'ion-logo': ionFn,
  'iconfont ': sameFn,
  'ti-': function ti(i) {
    return "themify-icon ".concat(i);
  },
  'bi-': function bi(i) {
    return "bootstrap-icons ".concat(i);
  }
};
var matMap = {
  o_: '-outlined',
  r_: '-round',
  s_: '-sharp'
};
var symMap = {
  sym_o_: '-outlined',
  sym_r_: '-rounded',
  sym_s_: '-sharp'
};
var libRE = new RegExp('^(' + Object.keys(libMap).join('|') + ')');
var matRE = new RegExp('^(' + Object.keys(matMap).join('|') + ')');
var symRE = new RegExp('^(' + Object.keys(symMap).join('|') + ')');
var mRE = /^[Mm]\s?[-+]?\.?\d/;
var imgRE = /^img:/;
var svgUseRE = /^svguse:/;
var ionRE = /^ion-/;
var faRE = /^(fa-(solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /;
export default Vue.extend({
  name: 'QIcon',
  mixins: [ListenersMixin, SizeMixin, TagMixin],
  props: {
    tag: {
      type: String,
      "default": 'i'
    },
    name: String,
    color: String,
    left: Boolean,
    right: Boolean
  },
  computed: {
    classes: function classes() {
      return 'q-icon' + (this.left === true ? ' on-left' : '') + (this.right === true ? ' on-right' : '') + (this.color !== void 0 ? " text-".concat(this.color) : '');
    },
    type: function type() {
      var _this = this;

      var cls;
      var icon = this.name;

      if (icon === 'none' || !icon) {
        return {
          none: true
        };
      }

      if (this.$q.iconMapFn !== void 0) {
        var res = this.$q.iconMapFn(icon);

        if (res !== void 0) {
          if (res.icon !== void 0) {
            icon = res.icon;

            if (icon === 'none' || !icon) {
              return {
                none: true
              };
            }
          } else {
            return {
              cls: res.cls,
              content: res.content !== void 0 ? res.content : ' '
            };
          }
        }
      }

      if (mRE.test(icon) === true) {
        var _icon$split = icon.split('|'),
            _icon$split2 = _slicedToArray(_icon$split, 2),
            def = _icon$split2[0],
            _icon$split2$ = _icon$split2[1],
            viewBox = _icon$split2$ === void 0 ? defaultViewBox : _icon$split2$;

        return {
          svg: true,
          viewBox: viewBox,
          nodes: def.split('&&').map(function (path) {
            var _path$split = path.split('@@'),
                _path$split2 = _slicedToArray(_path$split, 3),
                d = _path$split2[0],
                style = _path$split2[1],
                transform = _path$split2[2];

            return _this.$createElement('path', {
              attrs: {
                d: d,
                transform: transform
              },
              style: style
            });
          })
        };
      }

      if (imgRE.test(icon) === true) {
        return {
          img: true,
          src: icon.substring(4)
        };
      }

      if (svgUseRE.test(icon) === true) {
        var _icon$split3 = icon.split('|'),
            _icon$split4 = _slicedToArray(_icon$split3, 2),
            _def = _icon$split4[0],
            _icon$split4$ = _icon$split4[1],
            _viewBox = _icon$split4$ === void 0 ? defaultViewBox : _icon$split4$;

        return {
          svguse: true,
          src: _def.substring(7),
          viewBox: _viewBox
        };
      }

      var content = ' ';
      var matches = icon.match(libRE);

      if (matches !== null) {
        cls = libMap[matches[1]](icon);
      } else if (faRE.test(icon) === true) {
        cls = icon;
      } else if (ionRE.test(icon) === true) {
        cls = "ionicons ion-".concat(this.$q.platform.is.ios === true ? 'ios' : 'md').concat(icon.substr(3));
      } else if (symRE.test(icon) === true) {
        // "notranslate" class is for Google Translate
        // to avoid tampering with Material Symbols ligature font
        //
        // Caution: To be able to add suffix to the class name,
        // keep the 'material-symbols' at the end of the string.
        cls = 'notranslate material-symbols';

        var _matches = icon.match(symRE);

        if (_matches !== null) {
          icon = icon.substring(6);
          cls += symMap[_matches[1]];
        }

        content = icon;
      } else {
        // "notranslate" class is for Google Translate
        // to avoid tampering with Material Icons ligature font
        //
        // Caution: To be able to add suffix to the class name,
        // keep the 'material-icons' at the end of the string.
        cls = 'notranslate material-icons';

        var _matches2 = icon.match(matRE);

        if (_matches2 !== null) {
          icon = icon.substring(2);
          cls += matMap[_matches2[1]];
        }

        content = icon;
      }

      return {
        cls: cls,
        content: content
      };
    }
  },
  render: function render(h) {
    var data = {
      "class": this.classes,
      style: this.sizeStyle,
      on: _objectSpread({}, this.qListeners),
      attrs: {
        'aria-hidden': 'true',
        role: 'presentation'
      }
    };

    if (this.type.none === true) {
      return h(this.tag, data, slot(this, 'default'));
    }

    if (this.type.img === true) {
      return h('span', data, mergeSlot([h('img', {
        attrs: {
          src: this.type.src
        }
      })], this, 'default'));
    }

    if (this.type.svg === true) {
      return h('span', data, mergeSlot([h('svg', {
        attrs: {
          viewBox: this.type.viewBox || '0 0 24 24',
          focusable: 'false'
          /* needed for IE11 */

        }
      }, this.type.nodes)], this, 'default'));
    }

    if (this.type.svguse === true) {
      return h('span', data, mergeSlot([h('svg', {
        attrs: {
          viewBox: this.type.viewBox,
          focusable: 'false'
          /* needed for IE11 */

        }
      }, [h('use', {
        attrs: {
          'xlink:href': this.type.src
        }
      })])], this, 'default'));
    }

    if (this.type.cls !== void 0) {
      data["class"] += ' ' + this.type.cls;
    }

    return h(this.tag, data, mergeSlot([this.type.content], this, 'default'));
  }
});